import type { Language } from '../content/content';
import { languages } from '../content/content';

type LanguageButtonsProps = {
  onSelect: (language: Language) => void;
};

export function LanguageButtons({ onSelect }: LanguageButtonsProps) {
  return (
    <div className="languageGrid" aria-label="Language selection">
      {Object.entries(languages).map(([language, label]) => (
        <button
          className="languageButton"
          key={language}
          type="button"
          onClick={() => onSelect(language as Language)}
        >
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
}
